import { Box } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import React from "react";
import PrimaryButton from "../../../../Components/UI/Buttons/PrimaryButton";
import CustomSwitch from "../../../../Components/UI/Switch";
import { useStyles } from "../style";

const DocumentCard = ({ data, index, onDelete, handleUpdate }) => {
  const classes = useStyles();

  return (
    <Box>
      <Box style={{ marginBottom: 8 }}>
        <PrimaryButton
          hideIcon={true}
          onClick={() => {
            onDelete(index);
          }}
        >
          Delete
        </PrimaryButton>
      </Box>
      {data?.id && data?.file_path && (
        <Box className={classes.imageBox}>
          <img
            src={data?.file_path}
            width={"100%"}
            height={"100%"}
            alt={`image-${index}`}
            style={{ objectFit: "contain" }}
          />
        </Box>
      )}
      <DropzoneArea
        showFileNames
        filesLimit={1}
        showAlerts={false}
        acceptedFiles={["image/*"]}
        onDrop={(files) => {
          handleUpdate(index, "file", files[0]);
        }}
        clearOnUnmount={true}
      />
      <CustomSwitch
        label="Include in Gallery?"
        isFlex={true}
        isReverse={true}
        checked={data.is_gallery ?? false}
        onChange={(e) => {
          handleUpdate(index, "is_gallery", e.target.checked);
        }}
      />
    </Box>
  );
};

export default React.memo(DocumentCard);
